module.exports = "https://web-assets.ifttt.com/packs/media/docs/applet_example-d3fa1c5a.png";